import { useMap } from 'react-leaflet';

import { Avatar } from '../../../Atomics/Avatar';
import Box from '../../../Atomics/Box';
import CustomIcon from '../../../Icons/CustomIcon';

import { useTranslationContext } from '../../../../../contexts/TranslationContext';
import { StyledButton } from '../../../Atomics/Button';

export const UniLocationControl = () => {
    const { resources } = useTranslationContext();
    const map = useMap();

    const handleFlyToPosition = () => {
        map.flyTo([38.733, -9.1608703], 17);
    };

    return (
        <Box>
            <StyledButton onClick={() => handleFlyToPosition()} title={resources.label.universityLocation}>
                <Avatar bg="black-1" size={32}>
                    <CustomIcon icon="CampusBuildings" width="20" customColor="white" />
                </Avatar>
            </StyledButton>
        </Box>
    );
};
